import "./SidePanelTextLine.less";

export function SidePanelTextLine({ children }: { children?: string }) {
    return <span className="SidePanelTextLine gux-label">{children}</span>;
}
